<!-- 活动管理/数据分析-按配置导出-->
<template>
  <el-dialog title="导出字段设置" :visible.sync="dialogVisible" width="480px" @close="handleDialogClose">
    <div class="new-table-box">
      <el-table v-loading="exportFieldLoading" :data="tempExportFieldsData" style="width: 100%;" max-height="600"
        size="small" :row-key="getRowKey" border :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }" :cell-style="{ 'text-align': 'left' }">
        <el-table-column prop="label" label="名称" width="300">
        </el-table-column>
        <el-table-column prop="export" label="是否导出">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.export" :disabled="scope.row.disabled"
              @change="handleExportChange(scope.row)">
            </el-switch>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="settingButtom">
      <el-button :loading="exportFieldLoading" type="primary" @click="handleSave">确定</el-button>
      <el-button type="default" @click="handleDialogClose">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'ExportFieldSettingDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    exportFieldsData: {
      type: Array,
      default: () => []
    },
    exportFieldLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tempExportFieldsData: []
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.openDialog()
      }
    },
    // 监听 exportFieldsData 变化
    exportFieldsData: {
      handler(newVal) {
        // 只有在弹窗打开状态下才更新临时数据
        if (this.visible && newVal && newVal.length > 0) {
          this.tempExportFieldsData = JSON.parse(JSON.stringify(newVal))
        }
      },
      deep: true,
      immediate: false
    }
  },
  methods: {
    // 打开弹窗时，创建数据副本
    openDialog() {
      this.tempExportFieldsData = JSON.parse(JSON.stringify(this.exportFieldsData))
    },

    // 处理弹窗关闭（取消操作）
    handleDialogClose() {
      this.tempExportFieldsData = []
      this.$emit('update:visible', false)
      this.$emit('close')
    },

    // 处理导出字段变更
    handleExportChange(row) {
      // 如果是父级节点，同步更新所有子节点
      if (row.children && row.children.length > 0) {
        row.children.forEach(child => {
          child.export = row.export
        })
      }
      // 如果是子节点，检查父节点状态(确保子节点全部勾选时父节点才勾选)
      this.updateParentExportStatus()
    },

    // 更新父节点导出状态
    updateParentExportStatus() {
      this.tempExportFieldsData.forEach(parent => {
        if (parent.children && parent.children.length > 0) {
          const allChildrenExported = parent.children.every(child => child.export)
          parent.export = allChildrenExported
        }
      })
    },

    // 保存导出设置
    handleSave() {
      // 将临时数据传递给父组件
      this.$emit('save', JSON.parse(JSON.stringify(this.tempExportFieldsData)))
      console.log('保存的导出字段设置')
      // 关闭弹窗并清空临时数据
      this.tempExportFieldsData = []
    },

    getRowKey(row) {
      if (row.group) {
        return row.group + '_' + row.label;
      }
      if (row.prop) {
        // 遍历 tempExportFieldsData 找到包含此行的父级分组
        for (let parent of this.tempExportFieldsData) {
          if (parent.children && parent.children.includes(row)) {
            return parent.group + '_' + row.label + '_' + row.prop;
          }
        }
        return row.label + '_' + row.prop;
      }
      return row.label;
    }
  }
}
</script>

<style lang="scss" scoped>
.settingButtom {
  margin-top: 10px;
  text-align: end;
}
</style>